function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["colorSchemes", "components", "defaultColorScheme"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import deepmerge from '@mui/utils/deepmerge';
import cssVarsParser from "./cssVarsParser.js";
function prepareCssVars(theme) {
  var parserConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _parserConfig$getSele = parserConfig.getSelector,
    getSelector = _parserConfig$getSele === void 0 ? defaultGetSelector : _parserConfig$getSele,
    disableCssColorScheme = parserConfig.disableCssColorScheme,
    selector = parserConfig.colorSchemeSelector;
  // @ts-ignore - ignore components do not exist
  var _theme$colorSchemes = theme.colorSchemes,
    colorSchemes = _theme$colorSchemes === void 0 ? {} : _theme$colorSchemes,
    components = theme.components,
    _theme$defaultColorSc = theme.defaultColorScheme,
    defaultColorScheme = _theme$defaultColorSc === void 0 ? 'light' : _theme$defaultColorSc,
    otherTheme = _objectWithoutProperties(theme, _excluded);
  var _cssVarsParser = cssVarsParser(otherTheme, parserConfig),
    rootVars = _cssVarsParser.vars,
    rootCss = _cssVarsParser.css,
    rootVarsWithDefaults = _cssVarsParser.varsWithDefaults;
  var themeVars = rootVarsWithDefaults;
  var colorSchemesMap = {};
  var defaultScheme = colorSchemes[defaultColorScheme],
    otherColorSchemes = _objectWithoutProperties(colorSchemes, [defaultColorScheme].map(_toPropertyKey));
  Object.entries(otherColorSchemes || {}).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      scheme = _ref2[1];
    var _cssVarsParser2 = cssVarsParser(scheme, parserConfig),
      vars = _cssVarsParser2.vars,
      css = _cssVarsParser2.css,
      varsWithDefaults = _cssVarsParser2.varsWithDefaults;
    themeVars = deepmerge(themeVars, varsWithDefaults);
    colorSchemesMap[key] = {
      css: css,
      vars: vars
    };
  });
  if (defaultScheme) {
    // default color scheme vars should be merged last to set as default
    var _cssVarsParser3 = cssVarsParser(defaultScheme, parserConfig),
      css = _cssVarsParser3.css,
      vars = _cssVarsParser3.vars,
      varsWithDefaults = _cssVarsParser3.varsWithDefaults;
    themeVars = deepmerge(themeVars, varsWithDefaults);
    colorSchemesMap[defaultColorScheme] = {
      css: css,
      vars: vars
    };
  }
  function defaultGetSelector(colorScheme, cssObject) {
    var rule = selector;
    if (selector === 'class') {
      rule = '.%s';
    }
    if (selector === 'data') {
      rule = '[data-%s]';
    }
    if (selector !== null && selector !== void 0 && selector.startsWith('data-') && !selector.includes('%s')) {
      // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
      rule = "[".concat(selector, "=\"%s\"]");
    }
    if (colorScheme) {
      if (rule === 'media') {
        var _colorSchemes$colorSc;
        if (theme.defaultColorScheme === colorScheme) {
          return ':root';
        }
        var mode = ((_colorSchemes$colorSc = colorSchemes[colorScheme]) === null || _colorSchemes$colorSc === void 0 || (_colorSchemes$colorSc = _colorSchemes$colorSc.palette) === null || _colorSchemes$colorSc === void 0 ? void 0 : _colorSchemes$colorSc.mode) || colorScheme;
        return _defineProperty({}, "@media (prefers-color-scheme: ".concat(mode, ")"), {
          ':root': cssObject
        });
      }
      if (rule) {
        if (theme.defaultColorScheme === colorScheme) {
          return ":root, ".concat(rule.replace('%s', String(colorScheme)));
        }
        return rule.replace('%s', String(colorScheme));
      }
    }
    return ':root';
  }
  var generateThemeVars = function generateThemeVars() {
    var vars = _objectSpread({}, rootVars);
    Object.entries(colorSchemesMap).forEach(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
        schemeVars = _ref5[1].vars;
      vars = deepmerge(vars, schemeVars);
    });
    return vars;
  };
  var generateStyleSheets = function generateStyleSheets() {
    var stylesheets = [];
    var colorScheme = theme.defaultColorScheme || 'light';
    function insertStyleSheet(key, css) {
      if (Object.keys(css).length) {
        stylesheets.push(typeof key === 'string' ? _defineProperty({}, key, _objectSpread({}, css)) : key);
      }
    }
    insertStyleSheet(getSelector(undefined, _objectSpread({}, rootCss)), rootCss);
    var defaultSchemeVal = colorSchemesMap[colorScheme],
      other = _objectWithoutProperties(colorSchemesMap, [colorScheme].map(_toPropertyKey));
    if (defaultSchemeVal) {
      var _colorSchemes$colorSc2;
      // default color scheme has to come before other color schemes
      var _css = defaultSchemeVal.css;
      var cssColorSheme = (_colorSchemes$colorSc2 = colorSchemes[colorScheme]) === null || _colorSchemes$colorSc2 === void 0 || (_colorSchemes$colorSc2 = _colorSchemes$colorSc2.palette) === null || _colorSchemes$colorSc2 === void 0 ? void 0 : _colorSchemes$colorSc2.mode;
      var finalCss = !disableCssColorScheme && cssColorSheme ? _objectSpread({
        colorScheme: cssColorSheme
      }, _css) : _objectSpread({}, _css);
      insertStyleSheet(getSelector(colorScheme, _objectSpread({}, finalCss)), finalCss);
    }
    Object.entries(other).forEach(function (_ref7) {
      var _colorSchemes$key;
      var _ref8 = _slicedToArray(_ref7, 2),
        key = _ref8[0],
        css = _ref8[1].css;
      var cssColorSheme = (_colorSchemes$key = colorSchemes[key]) === null || _colorSchemes$key === void 0 || (_colorSchemes$key = _colorSchemes$key.palette) === null || _colorSchemes$key === void 0 ? void 0 : _colorSchemes$key.mode;
      var finalCss = !disableCssColorScheme && cssColorSheme ? _objectSpread({
        colorScheme: cssColorSheme
      }, css) : _objectSpread({}, css);
      insertStyleSheet(getSelector(key, _objectSpread({}, finalCss)), finalCss);
    });
    return stylesheets;
  };
  return {
    vars: themeVars,
    generateThemeVars: generateThemeVars,
    generateStyleSheets: generateStyleSheets
  };
}
export default prepareCssVars;